
import FancyRadio, { RadioType, OptionType } from './FancyRadio';

import Email from '@mui/icons-material/Email';


import { getIcon } from 'utils/misc';


function VisibilitySelectorForm({onChange, selectedVisibility}: {onChange: (i: string) => void, selectedVisibility: string}) {
    const VisibilityIcon = getIcon('Visibility');
    const VisibilityOff = getIcon('VisibilityOff');
    // const Diversity1 = getIcon('Diversity1');
    // const Public = getIcon('Public');
    const radio = {
        label: "Visibility",
        name: "visibility",
        value: selectedVisibility,
        setValue: onChange,
        helper: "Who can see this?",
        icon: <VisibilityIcon />,
    } as RadioType;

    const options = [
        { value: '0',
            text: 'Private',
            helper: "Just You",
            recommended: true,
            icon: <VisibilityOff />,
        } as OptionType,
        { value: '1',
            text: 'Dedicated',
            helper: "You and your dedicated team",
            icon: <Email />
        } as OptionType,
        // { value: '2',
        //     text: 'Mutuals',
        //     helper: "A (selection) of your mutuals, and your dedicated.",
        //     disabled: true,
        //     icon: <Diversity1 />
        // } as OptionType,
        // { value: '3',
        //     text: 'Public',
        //     helper: "Everybody",
        //     disabled: true,
        //     icon: <Public />
        // } as OptionType,
    ];

    return <FancyRadio radio={radio} options={options}/>;
}

export default VisibilitySelectorForm;
